import { render, staticRenderFns } from "./WalletModal.vue?vue&type=template&id=29f3ae6e"
import script from "./WalletModal.vue?vue&type=script&lang=js"
export * from "./WalletModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports